// extracted by mini-css-extract-plugin
export default {"card":"Unauthorized_card__-EOuR","title":"Unauthorized_title__x3EiR","text":"Unauthorized_text__VZveY","link":"Unauthorized_link__ZnxPM"};